import BasePage from "pages/base_page"

let NewSessionPage

export default NewSessionPage = (function () {
  NewSessionPage = class NewSessionPage extends BasePage {}

  return NewSessionPage
})()
